import type { AttendanceState } from '@pams/shared';

/**
 * ⚠️ A MODULE OF ITS OWN BECAUSE `react-refresh/only-export-components` REFUSES A FILE THAT
 * EXPORTS BOTH A COMPONENT AND SOMETHING ELSE — `pwa/src/components/tabs.ts`' reason, verbatim.
 * The rule is right: a non-component export from a component file breaks fast refresh for the
 * whole file. It is also the better shape here, because `attendanceTint.test.ts` READS this
 * source to recover the two alphas, and a file that is only the wash is a file that cannot
 * accidentally start containing something else.
 */
/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  ⚠️ [amended C3c.1] THE WASH IS AN `after:` OVERLAY, **NEVER** A SECOND `bg-*` ON THE CHIP —
 *  AND [C3c §7] SHIPPED THE SECOND, WHICH MADE IT INVISIBLE IN DARK MODE.
 *
 *  `cn` is `twMerge`-backed, and `bg-card` and `bg-attendance/8` are ONE tailwind-merge group.
 *  So `cn('bg-card', wash)` does not LAYER the wash over the card — it DELETES `bg-card` and
 *  paints the wash straight onto the page canvas. The comment beside it read "AFTER `bg-card`,
 *  so the wash wins", which is true and IS the defect: winning is replacement.
 *
 *  ⚠️ MEASURED, and dark mode is where it bit. `attendance` is `#94a3b8`; at 0.08 over the dark
 *  canvas `#0a0a0a` that composites to about rgb(21,22,24), while an UNWASHED chip is
 *  `card` = `#141414` = rgb(20,20,20). **≈1.02:1 — indistinguishable.** The STARTED wash did not
 *  exist for any operator on a dark theme — which, since [LIGHT-DEFAULT], is one who chose dark
 *  from the toggle rather than one whose laptop chose it for them.
 *
 *  ⚠️ AND THE GUARD COULD NOT SEE IT, because `attendanceTint.test.ts` composited the wash over
 *  `card` — the surface it was SUPPOSED to land on. It certified a ratio the screen did not
 *  have, which is verbatim the `contrastOn` trap that file's own header cites. Both halves are
 *  fixed together: the overlay makes `card` the real basis, and the guard now reads its alphas
 *  from THIS file and carries a perceptibility floor against an unwashed chip.
 *
 *  A pseudo-element is a different property group, so `twMerge` cannot collide it with the
 *  background; `isolate` on the chip bounds the negative z-index, so the overlay paints ABOVE
 *  the chip's own `bg-card` and BELOW its avatar and name. `TileCard`'s stretched
 *  `after:absolute after:inset-0` is the precedent, and Tailwind supplies `content: ''` for a
 *  `before:`/`after:` utility, so none is written here.
 *
 *  ⚠️ LITERAL CLASS STRINGS. Tailwind extracts candidates from source TEXT, so an interpolated
 *  ``after:bg-attendance/${n}`` generates NOTHING and the chip renders unwashed with `tsc`,
 *  `eslint` and `vitest` all green — `dashboardGrid.ts`'s recorded trap, one file over.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
/*
 * ⚠️ [amended C5c §5a] ONE WASH — ABSENT — AND THE STARTED ONE IS GONE (U6). A Start Duty is a
 * marking, and ANY marking reads `Present` on every surface now: the chip's word, Duty Mitra's
 * roster, the preview and the printed order. A light wash marking it as an exception said the
 * opposite of the word beside it. The absence wash is the one exception left, and it stays.
 */
export const ATTENDANCE_WASH: Partial<Record<AttendanceState, string>> = {
  ABSENT: 'after:absolute after:inset-0 after:-z-10 after:rounded-md after:bg-attendance/20',
};
